import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { APP } from '@/constants/testIds';
import { CalendarClock, Sprout } from 'lucide-react';

const ContextControls = ({ crops, year, setYear, season, setSeason, selectedCrop, setSelectedCrop }) => (
  <Card className="mb-6 border-icrisat-green/25 bg-icrisat-green-soft/60 animate-fade-up">
    <CardContent className="pt-5">
      <div className="flex items-center gap-2 mb-3">
        <CalendarClock className="h-5 w-5 text-icrisat-green" />
        <h3 className="font-display text-lg text-icrisat-green">Season · Year · Crop</h3>
        <span className="text-sm text-muted-foreground ml-2 hidden md:inline">
          Advisories below use these choices together with the selected farm's coordinates.
        </span>
      </div>
      <div className="grid gap-3 md:grid-cols-3">
        <div>
          <Label className="text-xs text-icrisat-earth">Season</Label>
          <Select value={season} onValueChange={setSeason}>
            <SelectTrigger data-testid={APP.seasonYear.season}><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="Kharif">Kharif (Vanakalam)</SelectItem>
              <SelectItem value="Rabi">Rabi (Yasangi)</SelectItem>
              <SelectItem value="Summer">Summer</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label className="text-xs text-icrisat-earth">Year</Label>
          <Input type="number" data-testid={APP.seasonYear.year} value={year} onChange={e => setYear(parseInt(e.target.value, 10) || year)} />
        </div>
        <div>
          <Label className="text-xs text-icrisat-earth flex items-center gap-1"><Sprout className="h-3 w-3" /> Focus crop</Label>
          <Select value={selectedCrop} onValueChange={setSelectedCrop}>
            <SelectTrigger data-testid={APP.seasonYear.selectedCrop}><SelectValue /></SelectTrigger>
            <SelectContent>
              {crops.map(c => (
                <SelectItem key={c.key} value={c.key}>{c.label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
    </CardContent>
  </Card>
);

export default ContextControls;
